// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ob-root {
  min-height: 100vh;
  background: var(--clr-bg);
  font-family: 'DM Sans', sans-serif;
  display: flex;
  flex-direction: column;
}

.ob-hdr {
  background: #fff;
  border-bottom: 1px solid var(--clr-border);
  padding: 14px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ob-hdr-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ob-hdr-logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  object-fit: contain;
  background: #fff;
  padding: 2px;
}

.ob-hdr-title {
  font-family: 'Outfit', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: var(--clr-dark);
}

.ob-hdr-sub {
  font-size: 11px;
  color: var(--clr-text-muted);
}

.ob-logout {
  padding: 6px 14px;
  border: 1.5px solid var(--clr-border);
  background: #fff;
  color: var(--clr-text-light);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 5px;
}

.ob-logout:hover {
  border-color: var(--clr-danger-border);
  color: var(--clr-danger);
  background: var(--clr-danger-bg);
}

.ob-body {
  flex: 1 1;
  display: flex;
  justify-content: center;
  padding: 28px 20px;
}

.ob-container {
  width: 100%;
  max-width: 720px;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding-right: 8px;
}

/* Container Scrollbar Styling */
.ob-container::-webkit-scrollbar {
  width: 6px;
}

.ob-container::-webkit-scrollbar-track {
  background: var(--clr-bg);
  border-radius: 8px;
}

.ob-container::-webkit-scrollbar-thumb {
  background: var(--clr-border-light);
  border-radius: 8px;
}

.ob-container::-webkit-scrollbar-thumb:hover {
  background: var(--clr-text-muted);
}

.ob-steps {
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
}

.ob-step {
  flex: 1 1;
  text-align: center;
  padding: 10px 0;
  border-radius: 10px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s;
  border: 1.5px solid var(--clr-border);
  background: #fff;
  color: var(--clr-text-muted);
}

.ob-step.active {
  background: linear-gradient(135deg, var(--clr-accent), var(--clr-accent-light));
  color: #fff;
  border-color: var(--clr-accent);
  box-shadow: 0 4px 14px rgba(67, 56, 202, .25);
}

.ob-step.done {
  background: var(--clr-success-bg);
  color: var(--clr-success);
  border-color: var(--clr-success-border);
}

.ob-card {
  background: #fff;
  border: 1px solid var(--clr-border);
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, .04);
  padding: 22px;
  margin-bottom: 16px;
}

.ob-card-title {
  font-family: 'Outfit', sans-serif;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 14px;
  color: var(--clr-dark);
}

.ob-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.ob-fg {
  margin-bottom: 10px;
}

.ob-fl {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--clr-text);
  margin-bottom: 3px;
}

.ob-fi {
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid var(--clr-border);
  border-radius: 9px;
  font-size: 12.5px;
  font-family: inherit;
  color: var(--clr-dark);
  outline: none;
}

.ob-fi:focus {
  border-color: var(--clr-accent-light);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, .06);
}

.ob-fi-file {
  padding: 7px 12px;
  background: var(--clr-bg-alt);
}

.ob-sel {
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid var(--clr-border);
  border-radius: 9px;
  font-size: 12.5px;
  font-family: inherit;
  color: var(--clr-dark);
  outline: none;
  appearance: none;
  background: #fff;
}

.ob-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 18px;
}

.ob-btn {
  padding: 8px 20px;
  background: linear-gradient(135deg, var(--clr-accent), var(--clr-accent-light));
  color: #fff;
  border: none;
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.ob-btn:hover {
  opacity: .9;
}

.ob-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.ob-btn-o {
  padding: 8px 20px;
  border: 1.5px solid var(--clr-border);
  background: #fff;
  color: var(--clr-text);
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.ob-btn-o:hover {
  border-color: var(--clr-accent-bg2);
  color: var(--clr-accent);
}

.ob-btn-ok {
  background: linear-gradient(135deg, var(--clr-success), var(--clr-success-light));
}

/* Preview Section with Scroll */
.ob-preview {
  border: 1.5px solid var(--clr-border);
  border-radius: 12px;
  padding: 18px;
  background: var(--clr-bg-alt);
  margin-bottom: 14px;
  max-height: 400px;
  overflow-y: auto;
}

/* Preview Scrollbar Styling */
.ob-preview::-webkit-scrollbar {
  width: 6px;
}

.ob-preview::-webkit-scrollbar-track {
  background: var(--clr-bg);
  border-radius: 8px;
}

.ob-preview::-webkit-scrollbar-thumb {
  background: var(--clr-border-light);
  border-radius: 8px;
}

.ob-preview::-webkit-scrollbar-thumb:hover {
  background: var(--clr-text-muted);
}

.ob-preview-sec {
  margin-bottom: 14px;
}

.ob-preview-sec-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--clr-accent);
  text-transform: uppercase;
  letter-spacing: .5px;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--clr-border);
}

.ob-preview-row {
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
  font-size: 12px;
}

.ob-preview-label {
  color: var(--clr-text-light);
  font-weight: 500;
}

.ob-preview-value {
  color: var(--clr-dark);
  font-weight: 600;
}

/* Pending State */
.ob-pending-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--clr-bg) 0%, var(--clr-accent-bg2) 100%);
  font-family: 'DM Sans', sans-serif;
}

.ob-pending-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, .1);
  padding: 48px 40px;
  text-align: center;
  max-width: 440px;
  width: 90%;
}

.ob-pending-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--clr-warning-bg), var(--clr-warning-border));
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 32px;
}

.ob-pending-title {
  font-family: 'Outfit', sans-serif;
  font-size: 22px;
  font-weight: 800;
  color: var(--clr-dark);
  margin-bottom: 6px;
}

.ob-pending-sub {
  font-size: 13.5px;
  color: var(--clr-text-light);
  line-height: 1.6;
  margin-bottom: 24px;
}

.ob-pending-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 20px;
  background: var(--clr-warning-bg);
  border: 1.5px solid var(--clr-warning-border);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--clr-warning);
  margin-bottom: 20px;
}

.ob-pending-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--clr-warning);
  animation: ob-pulse 1.5s infinite;
}

@keyframes ob-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: .3; }
}

/* Utility Classes */
.ob-span-2 {
  grid-column: span 2;
}

.ob-file-status {
  font-size: 11px;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 4px;
}

.ob-file-success {
  color: var(--clr-success);
  background: var(--clr-success-bg);
}

.ob-file-error {
  color: var(--clr-danger);
  background: var(--clr-danger-bg);
}

.ob-section {
  margin-bottom: 20px;
}

.ob-section-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--clr-text);
  margin-bottom: 12px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--clr-border);
}

.ob-textarea {
  resize: vertical;
  min-height: 70px;
}

.ob-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--clr-text);
  margin: 12px 0;
  cursor: pointer;
}

.ob-checkbox {
  width: 16px;
  height: 16px;
  accent-color: var(--clr-accent-light);
}

.has-error .ob-fi {
  border-color: var(--clr-danger);
}

.has-error .ob-fi:focus {
  border-color: var(--clr-danger);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.06);
}

.ob-field-error {
  font-size: 10px;
  color: var(--clr-danger);
  margin-top: 2px;
  font-weight: 500;
}

.required {
  color: var(--clr-danger);
  margin-left: 2px;
}

.ob-error-box {
  background: var(--clr-danger-bg);
  border: 1.5px solid var(--clr-danger-border);
  color: var(--clr-danger-dark);
  padding: 12px 16px;
  border-radius: 9px;
  font-size: 12px;
  margin-top: 16px;
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .ob-row {
    grid-template-columns: 1fr;
  }
  
  .ob-span-2 {
    grid-column: span 1;
  }
  
  .ob-steps {
    flex-wrap: wrap;
  }
  
  .ob-step {
    min-width: calc(50% - 2px);
  }
  
  .ob-actions {
    flex-wrap: wrap;
  }
  
  .ob-btn, .ob-btn-o {
    flex: 1 1;
    justify-content: center;
  }
  
  .ob-container {
    max-height: calc(100vh - 160px);
    padding-right: 4px;
  }
  
  .ob-preview {
    max-height: 350px;
  }
}

/* Firefox Scrollbar Support */
.ob-container {
  scrollbar-width: thin;
  scrollbar-color: var(--clr-border-light) var(--clr-bg);
}

.ob-preview {
  scrollbar-width: thin;
  scrollbar-color: var(--clr-border-light) var(--clr-bg);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/onboarding.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+EAA+E;EAC/E,WAAW;EACX,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+EAA+E;EAC/E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,iFAAiF;AACnF;;AAEA,gCAAgC;AAChC;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;EACjF,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qFAAqF;EACrF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,WAAW,EAAE;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;AACxD","sourcesContent":[".ob-root {\n  min-height: 100vh;\n  background: var(--clr-bg);\n  font-family: 'DM Sans', sans-serif;\n  display: flex;\n  flex-direction: column;\n}\n\n.ob-hdr {\n  background: #fff;\n  border-bottom: 1px solid var(--clr-border);\n  padding: 14px 28px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ob-hdr-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ob-hdr-logo {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  object-fit: contain;\n  background: #fff;\n  padding: 2px;\n}\n\n.ob-hdr-title {\n  font-family: 'Outfit', sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--clr-dark);\n}\n\n.ob-hdr-sub {\n  font-size: 11px;\n  color: var(--clr-text-muted);\n}\n\n.ob-logout {\n  padding: 6px 14px;\n  border: 1.5px solid var(--clr-border);\n  background: #fff;\n  color: var(--clr-text-light);\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.ob-logout:hover {\n  border-color: var(--clr-danger-border);\n  color: var(--clr-danger);\n  background: var(--clr-danger-bg);\n}\n\n.ob-body {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  padding: 28px 20px;\n}\n\n.ob-container {\n  width: 100%;\n  max-width: 720px;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n/* Container Scrollbar Styling */\n.ob-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ob-container::-webkit-scrollbar-track {\n  background: var(--clr-bg);\n  border-radius: 8px;\n}\n\n.ob-container::-webkit-scrollbar-thumb {\n  background: var(--clr-border-light);\n  border-radius: 8px;\n}\n\n.ob-container::-webkit-scrollbar-thumb:hover {\n  background: var(--clr-text-muted);\n}\n\n.ob-steps {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 24px;\n}\n\n.ob-step {\n  flex: 1;\n  text-align: center;\n  padding: 10px 0;\n  border-radius: 10px;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all .15s;\n  border: 1.5px solid var(--clr-border);\n  background: #fff;\n  color: var(--clr-text-muted);\n}\n\n.ob-step.active {\n  background: linear-gradient(135deg, var(--clr-accent), var(--clr-accent-light));\n  color: #fff;\n  border-color: var(--clr-accent);\n  box-shadow: 0 4px 14px rgba(67, 56, 202, .25);\n}\n\n.ob-step.done {\n  background: var(--clr-success-bg);\n  color: var(--clr-success);\n  border-color: var(--clr-success-border);\n}\n\n.ob-card {\n  background: #fff;\n  border: 1px solid var(--clr-border);\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, .04);\n  padding: 22px;\n  margin-bottom: 16px;\n}\n\n.ob-card-title {\n  font-family: 'Outfit', sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 14px;\n  color: var(--clr-dark);\n}\n\n.ob-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.ob-fg {\n  margin-bottom: 10px;\n}\n\n.ob-fl {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--clr-text);\n  margin-bottom: 3px;\n}\n\n.ob-fi {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1.5px solid var(--clr-border);\n  border-radius: 9px;\n  font-size: 12.5px;\n  font-family: inherit;\n  color: var(--clr-dark);\n  outline: none;\n}\n\n.ob-fi:focus {\n  border-color: var(--clr-accent-light);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, .06);\n}\n\n.ob-fi-file {\n  padding: 7px 12px;\n  background: var(--clr-bg-alt);\n}\n\n.ob-sel {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1.5px solid var(--clr-border);\n  border-radius: 9px;\n  font-size: 12.5px;\n  font-family: inherit;\n  color: var(--clr-dark);\n  outline: none;\n  appearance: none;\n  background: #fff;\n}\n\n.ob-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 18px;\n}\n\n.ob-btn {\n  padding: 8px 20px;\n  background: linear-gradient(135deg, var(--clr-accent), var(--clr-accent-light));\n  color: #fff;\n  border: none;\n  border-radius: 9px;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.ob-btn:hover {\n  opacity: .9;\n}\n\n.ob-btn:disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}\n\n.ob-btn-o {\n  padding: 8px 20px;\n  border: 1.5px solid var(--clr-border);\n  background: #fff;\n  color: var(--clr-text);\n  border-radius: 9px;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ob-btn-o:hover {\n  border-color: var(--clr-accent-bg2);\n  color: var(--clr-accent);\n}\n\n.ob-btn-ok {\n  background: linear-gradient(135deg, var(--clr-success), var(--clr-success-light));\n}\n\n/* Preview Section with Scroll */\n.ob-preview {\n  border: 1.5px solid var(--clr-border);\n  border-radius: 12px;\n  padding: 18px;\n  background: var(--clr-bg-alt);\n  margin-bottom: 14px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Preview Scrollbar Styling */\n.ob-preview::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ob-preview::-webkit-scrollbar-track {\n  background: var(--clr-bg);\n  border-radius: 8px;\n}\n\n.ob-preview::-webkit-scrollbar-thumb {\n  background: var(--clr-border-light);\n  border-radius: 8px;\n}\n\n.ob-preview::-webkit-scrollbar-thumb:hover {\n  background: var(--clr-text-muted);\n}\n\n.ob-preview-sec {\n  margin-bottom: 14px;\n}\n\n.ob-preview-sec-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--clr-accent);\n  text-transform: uppercase;\n  letter-spacing: .5px;\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--clr-border);\n}\n\n.ob-preview-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 3px 0;\n  font-size: 12px;\n}\n\n.ob-preview-label {\n  color: var(--clr-text-light);\n  font-weight: 500;\n}\n\n.ob-preview-value {\n  color: var(--clr-dark);\n  font-weight: 600;\n}\n\n/* Pending State */\n.ob-pending-root {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--clr-bg) 0%, var(--clr-accent-bg2) 100%);\n  font-family: 'DM Sans', sans-serif;\n}\n\n.ob-pending-card {\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, .1);\n  padding: 48px 40px;\n  text-align: center;\n  max-width: 440px;\n  width: 90%;\n}\n\n.ob-pending-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--clr-warning-bg), var(--clr-warning-border));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n  font-size: 32px;\n}\n\n.ob-pending-title {\n  font-family: 'Outfit', sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--clr-dark);\n  margin-bottom: 6px;\n}\n\n.ob-pending-sub {\n  font-size: 13.5px;\n  color: var(--clr-text-light);\n  line-height: 1.6;\n  margin-bottom: 24px;\n}\n\n.ob-pending-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 18px;\n  border-radius: 20px;\n  background: var(--clr-warning-bg);\n  border: 1.5px solid var(--clr-warning-border);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--clr-warning);\n  margin-bottom: 20px;\n}\n\n.ob-pending-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--clr-warning);\n  animation: ob-pulse 1.5s infinite;\n}\n\n@keyframes ob-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: .3; }\n}\n\n/* Utility Classes */\n.ob-span-2 {\n  grid-column: span 2;\n}\n\n.ob-file-status {\n  font-size: 11px;\n  margin-top: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.ob-file-success {\n  color: var(--clr-success);\n  background: var(--clr-success-bg);\n}\n\n.ob-file-error {\n  color: var(--clr-danger);\n  background: var(--clr-danger-bg);\n}\n\n.ob-section {\n  margin-bottom: 20px;\n}\n\n.ob-section-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--clr-text);\n  margin-bottom: 12px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--clr-border);\n}\n\n.ob-textarea {\n  resize: vertical;\n  min-height: 70px;\n}\n\n.ob-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--clr-text);\n  margin: 12px 0;\n  cursor: pointer;\n}\n\n.ob-checkbox {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--clr-accent-light);\n}\n\n.has-error .ob-fi {\n  border-color: var(--clr-danger);\n}\n\n.has-error .ob-fi:focus {\n  border-color: var(--clr-danger);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.06);\n}\n\n.ob-field-error {\n  font-size: 10px;\n  color: var(--clr-danger);\n  margin-top: 2px;\n  font-weight: 500;\n}\n\n.required {\n  color: var(--clr-danger);\n  margin-left: 2px;\n}\n\n.ob-error-box {\n  background: var(--clr-danger-bg);\n  border: 1.5px solid var(--clr-danger-border);\n  color: var(--clr-danger-dark);\n  padding: 12px 16px;\n  border-radius: 9px;\n  font-size: 12px;\n  margin-top: 16px;\n}\n\n/* Mobile Responsive */\n@media (max-width: 640px) {\n  .ob-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .ob-span-2 {\n    grid-column: span 1;\n  }\n  \n  .ob-steps {\n    flex-wrap: wrap;\n  }\n  \n  .ob-step {\n    min-width: calc(50% - 2px);\n  }\n  \n  .ob-actions {\n    flex-wrap: wrap;\n  }\n  \n  .ob-btn, .ob-btn-o {\n    flex: 1;\n    justify-content: center;\n  }\n  \n  .ob-container {\n    max-height: calc(100vh - 160px);\n    padding-right: 4px;\n  }\n  \n  .ob-preview {\n    max-height: 350px;\n  }\n}\n\n/* Firefox Scrollbar Support */\n.ob-container {\n  scrollbar-width: thin;\n  scrollbar-color: var(--clr-border-light) var(--clr-bg);\n}\n\n.ob-preview {\n  scrollbar-width: thin;\n  scrollbar-color: var(--clr-border-light) var(--clr-bg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
